import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {AxiosError} from "axios"
import {IManager, IManagerPayload} from "../../models/manager"

interface IManagerState {
  list: IManager[]
  pages: number,
  totalCount: number
  isLoading: boolean
  fetchError: any
}

const initialState: IManagerState = {
  list: [],
  pages: 0,
  totalCount: 0,
  isLoading: false,
  fetchError: {}
}

export const managerSlice = createSlice({
  name: "manager",
  initialState,
  reducers: {
    fetching(state) {
      state.isLoading = true
    },
    fetchSuccess(state, action: PayloadAction<IManagerPayload>) {
      state.isLoading = false
      state.list = action.payload.list
      state.pages = action.payload.pages
      state.totalCount = action.payload.totalCount
    },
    fetchError(state, action: PayloadAction<AxiosError>) {
      state.isLoading = false
      state.fetchError = action.payload.message
    }
  }
})

export default managerSlice.reducer